import React, {Component} from 'react';
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class UserProjects extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		
		let parms = "";
		//JSON.stringify(querystring.parse(this.props.location.search));
        	parms = parms.replace('?','');

	
		this.state = {
			contentId : JSON.parse(parms).id,
			content : {
			}
		};
		//this.handleDelete = this.handleDelete.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
		console.log('cid = ' + this.state.contentId);
  		axios.get(`${global.config.apiServicesUrl}/contents/${this.state.contentId}`).then(res => {
	 	this.setState({content : res.data });
		console.log(this.state.content);
				
		});
			
//	this.setState({blog : {...this.state.blog, [target.id] : target.value} });
//		this.setState({content : {...this.state.content, contentCData : "this is a test"} } );
			
		
	
	}
	handleChange = (event) => {
	
	}

	handleDelete = (id, event) => {

		//event.preventDefault();
		//console.log('deleting id - ' + id);
  		//axios.delete(`http://os-dev.origosoftware.com:3010/user-projects/${id}`).then(res => {
		//	const response = res.data;
	  	//	console.log(response);
		//});			
		//window.location.href('/projects');
	}

	render(){
	return (
	<form>



				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Content Editor
														</h3>
														<input class="form-control input-xlarge col-sm-8" placeholder="Search" />&nbsp;
														<a class="btn btn-success" href="#">New Content</a>&nbsp; 
							</div>
								<h4>{this.state.content.contentName}</h4>
	            					<div class="form-group row">
									<div class="col col-sm-12">
{/*
										<CKEditor
	                    					editor={ ClassicEditor }
    	                					data={ `${global.config.mediaServerUrl}${this.state.content.contentImageFile}`} 
//{this.state.content.contentCData}
        	            					onInit={ editor => {
            	            					// You can store the "editor" and use when it is needed.
            	            					// file:///usr/local/gazelle/home/GazelleCORE/system/Product%20Images/Woof.gif
            	            					editor.editing.view.change(writer => {
              										writer.setStyle(
                									"height",
                									"600px",
                									editor.editing.view.document.getRoot()
              										);
            									});
                	        					console.log( 'Editor is ready to use!', editor );
                    						} }
                    						onChange={ ( event, editor ) => {
                        						const data = editor.getData();
                       							 console.log( { event, editor, data } );
                    							} }
                    						onBlur={ ( event, editor ) => {
                        						console.log( 'Blur.', editor );
                    						} }
                    						onFocus={ ( event, editor ) => {
                        						console.log( 'Focus.', editor );
                    						} }
                					/>
*/}											
							</div>
						</div>            
					</div>		

	            </div>	
            </div>
            
			</div>
			</div>

		</div>			
	</form>
);


}
}

